/** Die Meldung des Backends aus einem Axios-Fehler, sonst der eigene Satz. Einmal für alle Winterchallenge-Seiten. */
export function messageOf(err: unknown, fallback: string): string {
  return (err as { response?: { data?: { error?: string } } })?.response?.data?.error ?? fallback;
}

/** HTTP-Status eines Axios-Fehlers, `null` ohne Antwort. */
export function statusOf(err: unknown): number | null {
  return (err as { response?: { status?: number } })?.response?.status ?? null;
}
